import React from 'react';
import StatCard from '../../components/ui/StatCard';
import { formatarMoeda } from '../../utils/formatters';

export default function ResumoCards({ simulacao }) {
  if (!simulacao) return null;

  const items = [
    { label: 'Primeira Parcela', valor: formatarMoeda(simulacao.informacoes.primeiraParcela), icon: '💰', iconColor: 'blue' },
    { label: 'Última Parcela', valor: formatarMoeda(simulacao.informacoes.ultimaParcela), icon: '🎯', iconColor: 'purple' },
    { label: 'Total de Juros', valor: formatarMoeda(simulacao.totais.totalJuros), icon: '📊', iconColor: 'gold' },
    { label: 'Total a Pagar', valor: formatarMoeda(simulacao.totais.totalAPagar), icon: '💵', iconColor: 'green' },
    {
      label: 'Idade Atual → Final',
      valor: `${simulacao.informacoes.idadeInicial} → ${simulacao.informacoes.idadeFinal} anos`,
      icon: '👤',
      iconColor: 'purple',
    },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginTop: 20 }}>
      {items.map((item, i) => (
        <StatCard key={i} icon={item.icon} iconColor={item.iconColor} label={item.label} value={item.valor} />
      ))}
    </div>
  );
}